export const navbar = {
  uz: {
    navHome: "Bosh sahifa",
    navAbout: "Biz haqimizda",
    navService: "Ximzatlar",
    navContact: "Kontaktlar",
    langTitleUz: "O'z",
    langTitleRu: "Ru",
    langTitleTj: "Tj",
    navPhoneContacts: "Filiallar telefon raqamlari",
    navBranchSamarkand: "Samarqand filiali",
    navBranchXatirchi: "Xatirchi filiali",
    navPhoneRegistration: "Ro'yxatga olish",
  },
  ru: {
    navHome: "Главная",
    navAbout: "О нас",
    navService: "Услуги",
    navContact: "Контакты",
    langTitleUz: "Уз",
    langTitleRu: "Ру",
    langTitleTj: "Тж",
    navPhoneContacts: "Телефоны филиалов",
    navBranchSamarkand: "Самаркандский филиал",
    navBranchXatirchi: "Хатырчинский филиал",
    navPhoneRegistration: "Регистратура",
  },
  tj: {
    navHome: "Асосӣ",
    navAbout: "Дар бораи мо",
    navService: "Хизматрасонӣ",
    navContact: "Тамос",
    langTitleUz: "Уз",
    langTitleRu: "Ру",
    langTitleTj: "Тҷ",
    navPhoneContacts: "Телефонҳои филиалҳо",
    navBranchSamarkand: "Филиали Самарқанд",
    navBranchXatirchi: "Филиали Хатирчи",
    navPhoneRegistration: "Бақайдгирӣ",
  },
};
